//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import PriceSelect from '@/components/buildings_top_filter/_price_select'
import ZoneSelect from '@/components/buildings_top_filter/_zone_select'
import CheckboxWrap from '@/components/buildings_top_filter/checkbox_wrap'
import { getLayoutOpts, getAreaOpts } from '@/components/buildings_top_filter/constant'
import page_log from '@/common/mixins/page_log'
export default {
    components: {
        PriceSelect,
        ZoneSelect,
        CheckboxWrap,
    },
    mixins: [
        page_log({ page_name: '一键找房' }),
    ],
    data () {
        return {
            price_select_show: false,
            zone_select_show: false,

            zone_tx: '不限',
            zone_ids: '',

            metro: '',

            location: '',
            distance: 0,
            ring_road: '',

            selected_layout: [],

            selected_area: [],
            selected_area_tx: [],

            total_price: '',
            price: '',
            price_tx: '不限',

            layout_opts: getLayoutOpts(),
            area_opts: getAreaOpts()
        }
    },
    computed: {
        location_tx () {
            return  `${this.zone_tx}${this.metro ? ` | ${this.metro}` : ''}`
        }
    },
    onShareAppMessage () {
        const sub_page = encodeURIComponent(`/pages/packageA/whole_buildings/main`)
        const shareOpt = {
            title: '好房多不用愁，定制需求帮您找满意的房子，快来试试吧~',
            path: `/pages/find_building/main?sub_page=${sub_page}`,
            share_by_prefix: 'sp201904182_'
        }
        return this.getShareInfo(shareOpt)
    },
    methods: {
        togglePriceSelect () {
            this.price_select_show = !this.price_select_show
        },
        toggleZoneSelect () {
            this.zone_select_show = !this.zone_select_show
        },
        hideSelect () {
            this.price_select_show = false
            this.zone_select_show = false
        },
        changePrice (type, tmp_price, selected_tx) {
            let type_tx = ''
            if (type === 'water') {
                type_tx = '总价'
                this.total_price = tmp_price
                this.price = ''
            } else {
                type_tx = '单价'
                this.price = tmp_price
                this.total_price = ''
            }
            if (tmp_price) {
                this.price_tx = `${type_tx}：${selected_tx}`
            } else {
                this.price_tx = '不限'
            }
            this.togglePriceSelect()
        },
        changeZoneMetro ({ zone_ids, text, zone_section_ids, metro, nearby, location, ring_road }) {
            this.zone_ids = zone_ids
            if (ring_road) {
                this.zone_tx = ring_road ? ring_road.text : ''
            } else {
                this.zone_tx = text
            }
            this.distance = nearby ? nearby.value : ''
            this.location = location || ''
            this.ring_road = ring_road ? ring_road.value : ''
            this.metro = metro
            this.toggleZoneSelect()
        },
        changeZone (zone_ids, zone_tx) {
            this.zone_ids = zone_ids
            this.zone_tx = zone_tx
        },
        changeMetro (metro) {
            this.metro = metro
            this.toggleZoneSelect()
        },
        changeLayout (layout) {
            this.selected_layout = layout
        },
        changeArea (selected_area, selected_area_tx) {
            this.selected_area = selected_area
            this.selected_area_tx = selected_area_tx
        },
        submit () {
            const params = {
                zone_tx: this.zone_tx,
                zone_ids: this.zone_ids,
                metro: this.metro,
                layout: this.selected_layout,
                area: this.selected_area,
                area_tx: this.selected_area_tx,
                total_price: this.total_price,
                price: this.price,
                price_tx: this.price_tx,
                location: this.location || '',
                distance: this.distance,
                ring_road: this.ring_road
            }
            const url = Object.keys(params).reduce((prev, key) => {
                prev += `${key}=${params[key]}&`
                return prev
            }, '/find_building/result?')

            this.$router.push({
                path: url
            })
        }
    }
}
